import { useAuthStore } from '../stores/authStore'

/** Ends the console session. The api has no sign-out route: the device token is simply forgotten. */
export function signOut(): void {
  useAuthStore.getState().clearSession()
}
